import React from "react";
import { useTranslation } from "react-i18next";

function PrivacyPolicy() {
  const { t } = useTranslation();
  const privacySections = t("pages.privacy.sections", { returnObjects: true });

  return (
    <main className="legal-page">
      <section className="legal-hero">
        <div className="main-container">
          <div className="legal-hero__content">
            <span className="legal-hero__kicker">PRO-VEST Capital Management</span>
            <h1 className="m-0 legal-hero__title">{t("pages.privacy.title")}</h1>
            <p className="m-0 legal-hero__text">{t("pages.privacy.text")}</p>
            <span className="legal-hero__date">{t("pages.privacy.lastUpdated")}</span>
          </div>
        </div>
      </section>
      <section className="legal-section">
        <div className="main-container">
          <div className="legal-content">
            <p className="legal-lead">{t("pages.privacy.lead")}</p>
            {privacySections.map((section) => (
              <article className="legal-card" key={section.title}>
                <h2>{section.title}</h2>
                <p>{section.text}</p>
              </article>
            ))}
            <div className="legal-notice">
              <h2>{t("pages.privacy.updatesTitle")}</h2>
              <p>{t("pages.privacy.updatesText")}</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
export default PrivacyPolicy;